// extracted by mini-css-extract-plugin
module.exports = {"accountSettings":"Account_accountSettings__3F9Z3","auditsAndInvoices":"Account_auditsAndInvoices__Wd2i8"};